module.exports = __webpack_public_path__ + "img/背景图@2x.8c61ab84.webp";